import React, { useCallback, useMemo } from 'react';
import { useIntl, getLocale } from 'umi';
import { Justify } from 'tea-component';
import SearchRecent from './SearchRecent';
import ExportTable from '@/pages/intelligence/components/ExportTable';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import { genreProfile } from '@intelligence/v3/constants/downloadLogPoint';

export default function SearchAndDownload(props: any) {
  const {
    isLoading,
    entityType,
    genreType,
    pageLogInfo,
    getFilterData,
    renderTableData,
    reset,
    total,
    filter = {},
    genreParams,
    apiParams,
    regionOptions,
    tableData,
  } = props;
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const searchType = useMemo(() => {
    return `genre_profile_${entityType}_${genreType}`;
  }, [entityType, genreType]);

  // const businessType = useMemo(() => {
  //   if (entityType === 'mobile' || entityType === 'total') {
  //     return 'genre-profile-download-page';
  //   }
  //   return 'genre-profile';
  // }, [entityType]);

  // const useWebDownloadCur = useMemo(() => {
  //   if (entityType === 'mobile' || entityType === 'total') {
  //     return true;
  //   }
  //   return false;
  // }, [entityType]);

  // 将表格接口返回的数据转换为组件内部需要的数据格式
  const transTableDataForSearch = (inputValue: string) => {
    const tableData = getFilterData(inputValue);
    return tableData?.map((item) => {
      const { searchKey, searchKeyCn } = item;
      return {
        ...item,
        name: locale === LANGUAGE_CN ? searchKeyCn || searchKey : searchKey,
      };
    });
  };

  // 将搜索记录的接口返回数据转换为组件内部需要的数据格式
  const transRecordDataForSearch = (res: any) => {
    const result = res?.data || [];
    return result?.map((item) => {
      const { metric_name } = item;
      return {
        name: metric_name,
      };
    });
  };

  // 将接口返回的搜索结果（表格数据）转换为添加搜索记录接口所需的数据格式
  const getAddRecordParams = (item) => {
    const { searchKey, searchKeyCn } = item;
    return {
      company_name: '',
      country_abbre: '',
      metric_cover_url: '',
      metric_id: searchKey,
      metric_name: locale === LANGUAGE_CN ? searchKeyCn || searchKey : searchKey,
    };
  };

  // 将组件返回的数据转换为删除记录接口所需的数据格式
  const getDeleteRecordParams = (item) => {
    const { name } = item;
    return {
      name,
    };
  };

  // 调用设置表格的方法，将搜索结果展示在前端
  const setTableSearchResult = (item) => {
    // 兼容搜索为空的情况,item会是undefined
    const searchResults = item ? [item] : [];
    renderTableData(searchResults);
  };

  const resetTableData = () => {
    reset();
  };

  //   下载需要的接口参数
  const getDownloadReqParams = useCallback(() => {
    const genreRequestParams =
      genreParams?.genre_source === 'sensortower'
        ? { sensortower_genre: genreParams?.sensortower_genre || [] }
        : { genre: genreParams?.genre || [] };
    // 在非mobile榜单时，设置mobile下载默认参数
    const defaultMobileDownloadParams = {
      regions: filter?.markets || ['global'],
      entity_type: 'mobile',
      regionType: 'market',
      genre_tab: 'mainsub',
      genreSegment: 'all',
      genre_source: genreParams?.genre_source || 'iegg',
      granularity: filter.granularity || 'monthly',
      start_date: filter?.startDate || '',
      end_date: filter?.endDate || '',
      iegg_genre_req: genreParams?.iegg_genre_req || [],
      ...genreRequestParams,
      source_metrics: {
        sensortower: [],
      },
      top_game_count: 4,
      page: 1,
      page_size: 9999,
    };
    const currentRequestParams = apiParams || defaultMobileDownloadParams;
    const currentGranularity =
      currentRequestParams.granularity || filter.granularity || 'monthly';
    const currentStartDate = currentRequestParams.start_date || filter?.startDate || '';
    const currentEndDate = currentRequestParams.end_date || filter?.endDate || '';

    // // 初始化使用iegg字段传入
    const paramsTemp = {
      genreType,
      genreSource:
        filter.genreSource === 'annie' ? 'appannie' : filter.genreSource || 'iegg',
      ...genreRequestParams,
      genre_source: genreParams?.genre_source,
      iegg_genre_req: genreParams?.iegg_genre_req,
      start_date: currentStartDate,
      end_date: currentEndDate,
      regions: filter?.markets,

      data_category: filter.dimension,
      market_type: filter.marketType,
      granularity: currentGranularity,
      dataSource: filter.dataSourceSingle?.value || 'sensortower',
      filter: {
        ...filter,
        granularity: currentGranularity,
        startDate: currentStartDate,
        endDate: currentEndDate,
      },
      requestParams: currentRequestParams,
      regionOptions,
      tableData,
    };
    return paramsTemp;
  }, [filter, regionOptions, apiParams, genreParams, tableData]);

  return (
    <>
      <Justify
        className="dbi-card-justify"
        right={
          <div className="justify-right">
            <SearchRecent
              key={searchType}
              disabled={isLoading}
              searchKey="keyword"
              searchType={searchType}
              isFrontEndSearch={true}
              pageLogInfo={pageLogInfo}
              isCustomRendering={true}
              transTableDataForSearch={transTableDataForSearch}
              transRecordDataForSearch={transRecordDataForSearch}
              getTableResultList={setTableSearchResult}
              handleClear={resetTableData}
              placeholder={formatMessage({ id: 'dbi_genre_profile_search_genre' })}
              getAddRecordParams={getAddRecordParams}
              getDeleteRecordParams={getDeleteRecordParams}
            />
            <ExportTable
              downloadModalSize={820}
              entityType={entityType}
              businessType={'genre-profile'}
              // useWebDownload={useWebDownloadCur}
              isDisableDownload={isLoading}
              downloadKey={'genreProfileTopCharts'}
              total={total}
              tableParams={getDownloadReqParams()}
              downloadLogConfigKey={genreProfile?.[`${entityType}_${genreType}`]}
            />
          </div>
        }
      />
    </>
  );
}
